import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatErr } from "../lib/api";
import Logo from "../components/Logo";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const { loginAdmin } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      await loginAdmin(username, password);
      toast.success("Welcome back, Admin");
      nav("/admin");
    } catch (e) {
      const msg = formatErr(e.response?.data?.detail) || "Login failed";
      setErr(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-[#F4F7F9]">
      <div className="w-full max-w-md">
        <Link
          to="/"
          data-testid="back-home"
          className="inline-flex items-center gap-1 text-sm text-[#475569] hover:text-[#1A3A5C] mb-4"
        >
          <ArrowLeft className="w-4 h-4" /> Back to Home
        </Link>
        <div className="bg-white rounded-2xl shadow-xl p-8 border border-slate-100">
          <div className="flex flex-col items-center">
            <Logo size={64} showTagline={false} />
            <h2 className="mt-5 font-serif font-bold text-2xl text-[#1A3A5C]">
              Admin Sign In
            </h2>
            <p className="text-sm text-[#475569] mt-1">
              Manage employees, projects & attendance
            </p>
          </div>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <Label htmlFor="username">Username</Label>
              <Input
                id="username"
                data-testid="admin-username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="admin"
                required
              />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                data-testid="admin-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
            {err && (
              <div data-testid="admin-login-error" className="text-sm text-red-600">
                {err}
              </div>
            )}
            <Button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full bg-[#1A3A5C] hover:bg-[#0F2236] text-white h-11"
            >
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
